import React, { useState, useEffect } from "react";
import "./style.css";
import cogoToast from "@successtar/cogo-toast";
import Moment from "react-moment";

function MasterControlProperty({ property, agentID }) {
  const [formData, setFormData] = useState({
    commissions: "",
    split: ""
  });

  useEffect(() => {
    console.log("Contact Card Mounted");
    setTimeout(() => {
      calculateCommissions(agentID);
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const calculateCommissions = (agentId) => {
    let commissions = 0;
    let split = 0;

    if (agentId === property.mainAgent) {
      commissions = property.premium * (property.mainAgentSplit / 100) * 0.06;
      split = property.mainAgentSplit;
    } else if (agentId === property.refAgentOne) {
      commissions = property.premium * (property.refAgentOneSplit / 100) * 0.06;
      split = property.refAgentOneSplit;
    } else if (agentId === property.refAgentTwo) {
      commissions = property.premium * (property.refAgentTwoSplit / 100) * 0.06;
      split = property.refAgentTwoSplit;
    } else if (agentId === property.refAgentThree) {
      commissions = property.premium * (property.refAgentThreeSplit / 100) * 0.06;
      split = property.refAgentThreeSplit;
    } else if (agentId === property.refAgentFour) {
      commissions = property.premium * (property.refAgentFour / 100) * 0.06;
      split = property.refAgentFourSplit;
    }

    setTimeout(() => {
      setFormData({
        commissions: commissions,
        split: split
      });
    }, 500);
  };

  const viewPolicy = (event) => {
    event.preventDefault();
    console.log("Getting Policy information");
    cogoToast.warn("Website Feature coming soon!");
  };

  const { split, commissions } = formData;

  return (
    <tr style={{ backgroundColor: "white" }}>
      <td>Property</td>
      <td>
        <strong>{`${property.clientFirstName} ${property.clientLastName}`}</strong>
      </td>
      <td>{property.policyActive ? "Active" : "Inactive"}</td>
      <td>${property.premium}</td>
      <td>
        {split ? <>{parseInt(split).toFixed(0)}%</> : <img alt="loading" src="/loading.gif" />}
      </td>
      <td>
        {commissions ? (
          <>${parseFloat(commissions).toFixed(2)}</>
        ) : (
          <img alt="loading" src="/loading.gif" />
        )}
      </td>
      <td>
        <Moment format="MM/DD" add={{ hours: 8 }}>
          {property.effectiveDate}
        </Moment>
      </td>
      <td>
        <Moment format="MM/DD" add={{ hours: 8 }}>
          {property.updatedAt}
        </Moment>
      </td>
      <td>
        <Moment format="MM/DD/YYYY" add={{ hours: 8 }}>
          {property.created_at}
        </Moment>
      </td>
      <td>
        <button
          className="btn btn-small btn-black"
          style={{ width: "100%" }}
          onClick={(e) => viewPolicy(e)}
        >
          View
        </button>
      </td>
    </tr>
  );
}

export default MasterControlProperty;
